import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            border: "1px solid #E5E1D8",
            background: "#FFFFFF",
            color: "#1A1D1A",
          },
        }}
      />
    </div>
  );
}

export default App;
